import { CommonModule } from "@angular/common";
import { LOCALE_ID, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { AppComponent } from "./app.component";
import { MaterialModule } from "./app.material.module";
import { AppRoutes } from "./app.routing";
import { AdminLayoutComponent } from "./layouts/admin/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth/auth-layout.component";
import { CoreModule } from "./modules/core/core/core.module";
import { NavbarModule } from "./modules/navbar/navbar.module";
import { FooterModule } from "./modules/shared/footer/footer.module";
import { SidebarModule } from "./modules/sidebar/sidebar.module";
import { SharedModule } from './modules/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    RouterModule.forRoot(AppRoutes, {
      useHash: true,
    }),
    MaterialModule,
    SidebarModule,
    NavbarModule,
    FooterModule,
    CoreModule,
    SharedModule,
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
  ],
  providers: [{ provide: LOCALE_ID, useValue: "es-CL" }],
  bootstrap: [AppComponent],
})
export class AppModule {}
